var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StudentWriteReviewDemoModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5427c6e6\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StudentWriteReviewDemoModal.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/user/StudentWriteReviewDemoModal.vue
// module id = 119
// module chunks = 8